// Shared by the HTML shells, actual exam controllers and guided audio URLs.
export const COURSE_VERSION = '20261003-headline-highlights-21';
